'use client'

import { useId } from 'react'
import { Checkbox } from '@/components/ui/checkbox'
import { cn } from '@/lib/utils'
import { EMAIL_CONSENT_TEXT } from '@/lib/crm/form-reoptin'

/**
 * Consent package 2d: the email consent line, an unchecked-by-default box that
 * sits under the SMS box on site forms. Ticking it (with
 * FORM_REOPTIN_LIFTS_SUPPRESSION on) clears that person's email holds, with a
 * proof row in sarah_consent_events. The form renders this only when the page
 * passes the switch state in, so with the switch off nothing on the page
 * changes. The sentence is Matt-approved public copy: do not reword it here,
 * change EMAIL_CONSENT_TEXT and bump FORM_CONSENT_WORDING_VERSION.
 */
export function EmailConsentDisclosure({
  className,
  tone = 'default',
  name = 'emailConsent',
  checked,
  onCheckedChange,
}: {
  className?: string
  tone?: 'default' | 'on-dark'
  /** Form field name submitted when checked (value "yes"). */
  name?: string
  checked?: boolean
  onCheckedChange?: (checked: boolean) => void
}) {
  const id = useId()
  return (
    <div data-email-consent="true" className={cn('flex items-start gap-2', className)}>
      <Checkbox
        id={id}
        name={name}
        value="yes"
        checked={checked}
        onCheckedChange={onCheckedChange ? (c) => onCheckedChange(c === true) : undefined}
        data-email-consent-checkbox="true"
        className={cn(
          'mt-0.5 shrink-0',
          tone === 'on-dark' &&
            'border-primary-foreground/60 data-[state=checked]:border-primary-foreground data-[state=checked]:bg-primary-foreground data-[state=checked]:text-primary',
        )}
      />
      <label
        htmlFor={id}
        className={cn(
          'cursor-pointer text-xs leading-relaxed',
          tone === 'on-dark' ? 'text-primary-foreground/70' : 'text-muted-foreground',
        )}
      >
        {EMAIL_CONSENT_TEXT}
      </label>
    </div>
  )
}
